import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoSearchDto } from '../../../shared/modules/base/dtos/base-proto-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AccountStatusEnum } from '../enums/account-status.enum';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * Account DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.ACCOUNT)
export class AccountSearchDto extends BaseProtoSearchDto {
	handle?: string | null;
	type!: AccountTypeEnum;
	status!: AccountStatusEnum;
	email!: string;
	contactShortName?: string;
	files?: FileDto[];

	displayValue(): string | null {
		return `${this.contactShortName}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return this.status;
	}
}
